import { gql } from '@apollo/client'

export default gql(`
  query($project: String){
    getAccessRoleGroups(project: $project){
      id
      name
    }
  }`
)
